/* eslint-disable no-console */
import clientInfo from 'common/lib/clientInfo';

const ENV = clientInfo.get('env');
const DEV_ENV = ENV === 'development' || ENV === 'test';

const copyMagicLog = (
  payload: any,
  options: { level: 'info' | 'log' | 'warn' | 'error' } = { level: 'info' },
) => {
  if (DEV_ENV || clientInfo.get('copyMagic.debug')) {
    console[options.level]('%c[CopyMagic]', 'color: pink;', payload);
  }
};

export default copyMagicLog;
